import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { PromoDTO } from "./useAllPromos.ts";
import { CreatePromoInput } from "./useCreatePromo.ts";

export function useUpdatePromo() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const updatePromo = async (
    promoId: string,
    input: CreatePromoInput,
  ): Promise<PromoDTO> => {
    try {
      setLoading(true);
      const { data } = await createAxiosInstance().post<PromoDTO>(
        `/promos/update/${promoId}`,
        input,
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { updatePromo, loading };
}
